// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__aRz8I","active":"Pagination_active__+S8ec","disabled":"Pagination_disabled__aQTHO","isSticky":"Pagination_isSticky__KWIc5"};